export const ABSTRACT_CONDITION_TYPES = {
  INTEGER_COMPARISON: 'INTEGER_COMPARISON',
  STATUS_COMPARISON: 'STATUS_COMPARISON',
  LANGUAGE_COMPARISON: 'LANGUAGE_COMPARISON',
  GPIO_COMPARISON: 'GPIO_COMPARISON',
  OR_COMPARISON: 'OR_COMPARISON',
  AND_COMPARISON: 'AND_COMPARISON',
  BOOLEAN_COMPARISON: 'BOOLEAN_COMPARISON',
  FUNCTION: 'FUNCTION',
}